import { render, staticRenderFns } from "./sendRuleConfig.vue?vue&type=template&id=7110c1e4&scoped=true&"
import script from "./sendRuleConfig.vue?vue&type=script&lang=js&"
export * from "./sendRuleConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7110c1e4",
  null
  
)

component.options.__file = "sendRuleConfig.vue"
export default component.exports